import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import logo from "../imagenes/logomadlex.png";
import logoMini from "../imagenes/logomadlex-ma.png";
import CurrentUser from "./CurrentUser";

export const MODULOS_DICT = {
  Moneda: "Divisas",
  TipoProceso: "Tipo Proceso",
  TipoTribunal: "Tipo Tribunal",
  RolTribunal: "Rol Tribunal",
  Pais: "Paises",
  ContactoTipo: "Tipo Contacto",
  ContactoClase: "Clase Contacto",
  Direccion: "Direcciones",
  GeoAdmin: "Localización",
  DireccionUnidad: "Tipo de unidad de dirección",
  TipoDireccion: "Tipo de Dirección",
  PersonaEmpresa: "Tipo de Dirección",
  Etapa: "Tipo de Dirección",
  ConceptoDeuda: "Tipo de Dirección",
  Activo: "Tipo de Activos",
  OrigenDatos: "Origen de datos",
  CargaMasiva: "Carga Masiva",
  ResultadosCarga: "Carga Masiva",
  ConceptoGasto: "Concepto de Gasto",
  ResultadoGestiones: "Resultados de Gestiones",
  TipoGestiones: "Tipo de Gestiones",
  TraspasoDeudas: "Causas",
  BusquedaCausas: "Causas",
};

// Iconos SVG inline (heroicons style)
const Icons = {
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
  ),
  search: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  ),
  transfer: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
    </svg>
  ),
  upload: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
    </svg>
  ),
  download: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
    </svg>
  ),
  chart: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  // Iconos de secciones de Mantenedores (visibles con el sidebar colapsado)
  users: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  ),
  scale: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
    </svg>
  ),
  globe: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  location: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  phone: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
    </svg>
  ),
  building: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  ),
  briefcase: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  document: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  clipboard: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
    </svg>
  ),
  dots: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
    </svg>
  ),
};

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

const Sidebar = (props) => {
  const { history } = props;
  const [usuario] = useState(CurrentUser.user);
  const currentPath =
    (history.location && history.location.pathname) || "";

  const isActive = (route) => currentPath === route;

  // Auto-expand la sección que contiene la ruta actual
  const sectionContainsActive = (routes) =>
    routes.some((r) => currentPath === r);

  const [expandedSections, setExpandedSections] = useState(() => ({
    usuarios: sectionContainsActive(["/Usuarios", "/Perfiles"]),
    tribunales: sectionContainsActive([
      "/Tribunal",
      "/TipoTribunal",
      "/RolTribunal",
    ]),
    geografia: sectionContainsActive(["/Pais", "/Estados", "/GeoAdmin"]),
    direcciones: sectionContainsActive([
      "/Direccion",
      "/DireccionUnidad",
      "/TipoDireccion",
    ]),
    contactos: sectionContainsActive(["/ContactoTipo", "/ContactoClase"]),
    personas: sectionContainsActive([
      "/PersonaEmpresa",
      "/Relaciones",
      "/Activo",
    ]),
    clientes: sectionContainsActive(["/Cliente", "/Cartera"]),
    procesos: sectionContainsActive([
      "/TipoProceso",
      "/Etapa",
      "/ConceptoDeuda",
      "/ConceptoGasto",
      "/Titulos",
      "/OrigenDatos",
    ]),
    gestiones: sectionContainsActive([
      "/TipoGestiones",
      "/ResultadoGestiones",
    ]),
    otros: sectionContainsActive(["/Moneda", "/Unidades"]),
  }));

  const toggleSection = (key) => {
    setExpandedSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Rutas que cualquier usuario logueado puede acceder sin necesidad de
  // tenerlas en su lista de modulosAdministracion. El control de acceso real
  // de cada una se hace dentro de la propia pagina (p.ej. KPI valida con
  // QuickSight si el usuario esta registrado como Reader).
  const OPEN_ROUTES = new Set(["Separacion", "Kpi"]);

  const changePage = (param) => {
    const route = param.startsWith("/") ? param.slice(1) : param;
    if (OPEN_ROUTES.has(route)) {
      return history.push("/" + route);
    }
    if (
      usuario &&
      usuario.modulosAdministracion &&
      usuario.modulosAdministracion.indexOf(route) === -1 &&
      usuario.modulosAdministracion.indexOf(MODULOS_DICT[route]) === -1
    ) {
      alert("No tienes acceso a ese modulo");
    } else {
      history.push("/" + route);
    }
  };

  const NavItem = ({ icon, label, route }) => (
    <div
      className={`sidebarNavItem ${isActive(route) ? "is-active" : ""}`}
      onClick={() => changePage(route)}
    >
      <span className="sidebarNavIcon">{icon}</span>
      <span className="sidebarNavLabel">{label}</span>
    </div>
  );

  const SubItem = ({ label, route }) => (
    <div
      className={`sidebarSubItem ${isActive(route) ? "is-active" : ""}`}
      onClick={() => changePage(route)}
    >
      {label}
    </div>
  );

  // Sección colapsable con sub-header clicable
  const CollapsibleSection = ({ id, title, icon, children }) => {
    const isOpen = expandedSections[id];
    return (
      <div className="sidebarSection">
        <div
          className={`sidebarSectionTitle sidebarSectionTitle--collapsible ${
            isOpen ? "is-expanded" : ""
          }`}
          onClick={() => toggleSection(id)}
          title={title}
        >
          <span className="sidebarSectionIcon">{icon}</span>
          <span className="sidebarSectionText">{title}</span>
          <span className="sidebarSectionChevron">▾</span>
        </div>
        {isOpen && <div className="sidebarSectionItems">{children}</div>}
      </div>
    );
  };

  // Footer compartido con avatar de usuario
  const Footer = () =>
    usuario && usuario.account ? (
      <div className="sidebarFooter">
        <div className="sidebarUserAvatar">{getInitials(usuario.account.name)}</div>
        <div className="sidebarUserInfo">
          <div className="sidebarUserName">{usuario.account.name}</div>
          <div className="sidebarUserEmail">{usuario.account.username}</div>
        </div>
      </div>
    ) : null;

  // tipo="1" = Procesos de cobranza (Causas Judiciales)
  if (props.tipo === "1") {
    return (
      <nav className="navbar navbar-inverse sidebar" id="sidebarHover" role="navigation">
        <div className="sidebarBrand" onClick={() => changePage("/Separacion")}>
          <img alt="logo" className="sidebarLogoMini" src={logoMini} />
          <img alt="logo" id="logo" className="sidebarLogoFull" src={logo} />
        </div>

        <div className="sidebarBody">
          <div className="sidebarSection">
            <div className="sidebarSectionTitle">PRINCIPAL</div>
            <NavItem icon={Icons.home} label="Inicio" route="/Separacion" />
          </div>

          <div className="sidebarSection">
            <div className="sidebarSectionTitle">PROCESOS DE COBRANZA</div>
            <NavItem icon={Icons.search} label="Búsqueda de causas" route="/BusquedaCausas" />
            <NavItem icon={Icons.transfer} label="Traspaso de deudas" route="/TraspasoDeudas" />
          </div>

          <div className="sidebarSection">
            <div className="sidebarSectionTitle">CARGA</div>
            <NavItem icon={Icons.upload} label="Carga Masiva" route="/CargaMasiva" />
            <NavItem icon={Icons.download} label="Resultados de Carga" route="/ResultadosCarga" />
          </div>

          <div className="sidebarSection">
            <div className="sidebarSectionTitle">REPORTES</div>
            <NavItem icon={Icons.chart} label="KPI" route="/Kpi" />
          </div>
        </div>

        <Footer />
      </nav>
    );
  }

  // tipo="2" = Mantenedores
  if (props.tipo === "2") {
    return (
      <nav className="navbar navbar-inverse sidebar" id="sidebarHover" role="navigation">
        <div className="sidebarBrand" onClick={() => changePage("/Separacion")}>
          <img alt="logo" className="sidebarLogoMini" src={logoMini} />
          <img alt="logo" id="logo" className="sidebarLogoFull" src={logo} />
        </div>

        <div className="sidebarBody">
          <div className="sidebarSection">
            <div className="sidebarSectionTitle">PRINCIPAL</div>
            <NavItem icon={Icons.home} label="Inicio" route="/Separacion" />
          </div>

          <CollapsibleSection id="usuarios" title="USUARIOS Y PERFILES" icon={Icons.users}>
            <SubItem label="Usuarios" route="/Usuarios" />
            <SubItem label="Perfiles" route="/Perfiles" />
          </CollapsibleSection>

          <CollapsibleSection id="tribunales" title="TRIBUNALES" icon={Icons.scale}>
            <SubItem label="Tribunal" route="/Tribunal" />
            <SubItem label="Tipo tribunal" route="/TipoTribunal" />
            <SubItem label="Libro/Tipo" route="/RolTribunal" />
          </CollapsibleSection>

          <CollapsibleSection id="geografia" title="GEOGRAFÍA" icon={Icons.globe}>
            <SubItem label="País" route="/Pais" />
            <SubItem label="Estados" route="/Estados" />
            <SubItem label="Localizaciones" route="/GeoAdmin" />
          </CollapsibleSection>

          <CollapsibleSection id="direcciones" title="DIRECCIONES" icon={Icons.location}>
            <SubItem label="Direcciones" route="/Direccion" />
            <SubItem label="Unidad de dirección" route="/DireccionUnidad" />
            <SubItem label="Tipo de dirección" route="/TipoDireccion" />
          </CollapsibleSection>

          <CollapsibleSection id="contactos" title="CONTACTOS" icon={Icons.phone}>
            <SubItem label="Tipo Contacto" route="/ContactoTipo" />
            <SubItem label="Clase Contacto" route="/ContactoClase" />
          </CollapsibleSection>

          <CollapsibleSection id="personas" title="PERSONAS Y EMPRESAS" icon={Icons.building}>
            <SubItem label="Persona/Empresa" route="/PersonaEmpresa" />
            <SubItem label="Relaciones" route="/Relaciones" />
            <SubItem label="Tipos de activos" route="/Activo" />
          </CollapsibleSection>

          <CollapsibleSection id="clientes" title="CLIENTES Y CARTERAS" icon={Icons.briefcase}>
            <SubItem label="Clientes" route="/Cliente" />
            <SubItem label="Carteras" route="/Cartera" />
          </CollapsibleSection>

          <CollapsibleSection id="procesos" title="PROCESOS Y CAUSAS" icon={Icons.document}>
            <SubItem label="Tipo de proceso" route="/TipoProceso" />
            <SubItem label="Etapa" route="/Etapa" />
            <SubItem label="Concepto Deuda" route="/ConceptoDeuda" />
            <SubItem label="Concepto de gasto" route="/ConceptoGasto" />
            <SubItem label="Titulos" route="/Titulos" />
            <SubItem label="Origen de datos" route="/OrigenDatos" />
          </CollapsibleSection>

          <CollapsibleSection id="gestiones" title="GESTIONES" icon={Icons.clipboard}>
            <SubItem label="Tipo de gestiones" route="/TipoGestiones" />
            <SubItem label="Resultados de gestiones" route="/ResultadoGestiones" />
          </CollapsibleSection>

          <CollapsibleSection id="otros" title="OTROS" icon={Icons.dots}>
            <SubItem label="Moneda" route="/Moneda" />
            <SubItem label="Unidades" route="/Unidades" />
          </CollapsibleSection>
        </div>

        <Footer />
      </nav>
    );
  }

  // Default: solo logo y inicio
  return (
    <nav className="navbar navbar-inverse sidebar" id="sidebarHover" role="navigation">
      <div className="sidebarBrand" onClick={() => changePage("/Separacion")}>
        <img alt="logo" className="sidebarLogoMini" src={logoMini} />
        <img alt="logo" id="logo" className="sidebarLogoFull" src={logo} />
      </div>

      <div className="sidebarBody">
        <div className="sidebarSection">
          <div className="sidebarSectionTitle">PRINCIPAL</div>
          <NavItem icon={Icons.home} label="Inicio" route="/Separacion" />
        </div>
      </div>

      <Footer />
    </nav>
  );
};

export default withRouter(Sidebar);
